import { mountTutorialNavigation } from "./tutorial-navigation.js";

mountTutorialNavigation();
